import { createContext } from "react";
import { ModalConfig } from "./types";

type ModalContext = {
  modalConfig: ModalConfig;
  modalIsOpen: boolean;
  openModal: (config: ModalConfig) => void;
  closeModal: () => void;
};

export const ModalContext = createContext({} as ModalContext);
